export type MetricUnknownReason = 'unavailable' | 'unsupported' | 'delayed' | 'error';

export type KnownMetric = {
  status: 'known';
  value: number;
};

export type UnknownMetric = {
  status: 'unknown';
  reason?: MetricUnknownReason;
};

export type ProfileMetric = KnownMetric | UnknownMetric;

export type ProfileStats = {
  totalSimulationsRun: ProfileMetric;
  mapsSaved: ProfileMetric;
  loginCount: ProfileMetric;
  layersCreated: ProfileMetric;
  routesGenerated: ProfileMetric;
  activeDays: ProfileMetric;
};

export type ProfileNetworkSettings = {
  data?: {
    networks?: Array<{
      networkSettings?: {
        timezone?: string;
      };
    }>;
  };
};

export const unknownMetric = (reason: MetricUnknownReason = 'unavailable'): UnknownMetric => ({
  status: 'unknown',
  reason,
});

export const knownMetric = (value: number): KnownMetric => ({
  status: 'known',
  value,
});

export const createUnknownProfileStats = (): ProfileStats => ({
  totalSimulationsRun: unknownMetric(),
  mapsSaved: unknownMetric(),
  loginCount: unknownMetric(),
  layersCreated: unknownMetric(),
  routesGenerated: unknownMetric(),
  activeDays: unknownMetric(),
});

export const getMetricValue = (metric?: ProfileMetric): number | undefined => (
  metric?.status === 'known' ? metric.value : undefined
);

export type ProfileBadge = {
  id: string;
  label: string;
  description: string;
  threshold: number;
};
